import React from 'react';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { FcDataConfiguration } from 'react-icons/fc';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { Body } from '../styles';
import BasicInformation from './BasicInformation';

const DataBlock = ({ client, isTeamSettings, team }) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <BootstrapToolTip
                text={'Client Details'}
                cssStyles={'top:-70% !important; min-width: fit-content !important;'}
            >
                <FcDataConfiguration className="icon purple" onClick={() => setShowModal(true)} />
            </BootstrapToolTip>

            <Modal show={showModal} backdropClassName="bg-dark" onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <strong>Client Details</strong>
                </Modal.Header>
                <Modal.Body className="modal-body">
                    <Body>
                        <BasicInformation clientId={client?._id} teamId={team} />
                    </Body>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default DataBlock;
